module.exports = __webpack_public_path__ + "img/img-bottom.babf144b.jpg";